import {combineReducers} from 'redux'
import config from '../config'
import {PROVIDER_LINKS_LOADED, PROVIDER_STREAM_LOADED, PROVIDER_SUGGEST_LOADED, PROVIDER_SUGGEST_QUERIED, PROVIDER_COVERAGE_LOADED, PROVIDER_LOADED, CONTACT_LINKS_LOADED, CONTACT_STREAM_LOADED, CONTACT_STREAM_QUERIED, CONTACT_SUGGEST_LOADED, CONTACT_SUGGEST_QUERIED, CONTACT_LOADED} from './actions'
import {PROVIDER_CRITERIA_UPDATED, PROVIDER_MINOR_CRITERIA_UPDATED, PROVIDER_COVERAGE_CRITERIA_UPDATED, CONTACT_CRITERIA_UPDATED, CONTACT_FILTER_UPDATED, CONTACT_MINOR_CRITERIA_UPDATED, CONTACT_MINOR_CRITERIA_RESET} from './actions'
import {REFERENCE_PROVIDER_COMPANY_CMD_UPDATED, ADD_PROVIDER_CONTACT_CMD_UPDATED, UPDATE_PROVIDER_CONTACT_CMD_UPDATED, ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED, ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED, DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED, DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED, DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED, DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED, SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED, DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED, DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED, DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED, EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED} from './actions'
import {REFERENCE_PROVIDER_COMPANY_CMD_SENT, ADD_PROVIDER_CONTACT_CMD_SENT, UPDATE_PROVIDER_CONTACT_CMD_SENT, ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT, ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT, DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT, DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT, DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT, DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT, SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT, DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT, DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT, DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT, EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT} from './actions'
import {PROVIDER_STREAM_QUERIED, PROVIDER_MINOR_CRITERIA_RESETTED} from './actions'

function stream(state = [], action) {
    switch (action.type) {
        case PROVIDER_STREAM_LOADED:
        case PROVIDER_STREAM_QUERIED:
            return action.stream
        default:
            return state
    }
}

function range(state = null, action) {
    switch (action.type) {
        case PROVIDER_STREAM_LOADED:
        case PROVIDER_STREAM_QUERIED:
            return action.range
        default:
            return state
    }
}

function _links(state = [], action) {
    switch (action.type) {
        case PROVIDER_LINKS_LOADED:
        case PROVIDER_STREAM_LOADED:
        case PROVIDER_STREAM_QUERIED:
            return action._links
        default:
            return state
    }
}

function query(state = null, action) {
    switch (action.type) {
        case PROVIDER_STREAM_LOADED:
        case PROVIDER_STREAM_QUERIED:
            return action.query
        default:
            return state
    }
}

function suggest(state = [], action) {
    switch (action.type) {
        case PROVIDER_SUGGEST_LOADED:
        case PROVIDER_SUGGEST_QUERIED:
            return action.suggest
        default:
            return state
    }
}

function criteria(state = null, action) {
    switch (action.type) {
        case PROVIDER_CRITERIA_UPDATED:
            return {...state, ...action.criteria}
        default:
            return state
    }
}

function minorCriteria(state = null, action) {
    switch (action.type) {
        case PROVIDER_MINOR_CRITERIA_UPDATED:
            return {...state, ...action.minorCriteria}
        case PROVIDER_MINOR_CRITERIA_RESETTED:
            return null
        default:
            return state
    }
}

function provider(state = null, action) {
    switch (action.type) {
        case PROVIDER_LOADED:
            return action.provider
        default:
            return state
    }
}

function referenceProviderCompanyCmd(state = null, action) {
    switch (action.type) {
        case REFERENCE_PROVIDER_COMPANY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case REFERENCE_PROVIDER_COMPANY_CMD_SENT:
            return null
        default:
            return state
    }
}

function addProviderContactCmd(state = null, action) {
    switch (action.type) {
        case ADD_PROVIDER_CONTACT_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ADD_PROVIDER_CONTACT_CMD_SENT:
            return null
        default:
            return state
    }
}

function updateProviderContactCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_PROVIDER_CONTACT_CMD_UPDATED:
            return {...state, ...action.cmd}
        case UPDATE_PROVIDER_CONTACT_CMD_SENT:
            return null
        default:
            return state
    }
}

function associateProviderContactWithProviderCompanyCmd(state = null, action) {
    switch (action.type) {
        case ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT:
            return null
        default:
            return state
    }
}

function assignActivityToProviderCompanyCmd(state = null, action) {
    switch (action.type) {
        case ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT:
            return null
        default:
            return state
    }
}

function defineUpdateInterventionPeriodForActivityCmd(state = null, action) {
    switch (action.type) {
        case DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT:
            return null
        default:
            return state
    }
}

function defineServiceChargeForInterventionPeriodCmd(state = null, action) {
    switch (action.type) {
        case DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
            return {...state, ...action.cmd}
        case DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT:
            return null
        default:
            return state
    }
}

function defineInterventionZoneForInterventionPeriodCmd(state = null, action) {
    switch (action.type) {
        case DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
            return {...state, ...action.cmd}
        case DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT:
            return null
        default:
            return state
    }
}

function defineCallOutChargesForInterventionPeriodCmd(state = null, action) {
    switch (action.type) {
        case DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
            return {...state, ...action.cmd}
        case DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT:
            return null
        default:
            return state
    }
}

function subscribeProviderCompanyToDirectoryForInterventionPeriodCmd(state = null, action) {
    switch (action.type) {
        case SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
            return {...state, ...action.cmd}
        case SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT:
            return null
        default:
            return state
    }   
}

function defineContactInfosForProviderCompanyCmd(state = null, action) {
    switch (action.type) {
        case DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT:
            return null
        default:
            return state
    }
}

function defineRepairTimelimitForInterventionPeriodCmd(state = null, action) {
    switch (action.type) {
        case DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
            return {...state, ...action.cmd}
        case DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT:
            return null
        default:
            return state
    }
}

function defineInterventionTimelimitForInterventionPeriodCmd(state = null, action) {
    switch (action.type) {
        case DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
            return {...state, ...action.cmd}
        case DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT:
            return null
        default:
            return state
    }
}

function excludeOpeningTicketPurposesFromInterventionPeriodCmd(state = null, action) {
    switch (action.type) {
        case EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED:
            return {...state, ...action.cmd}
        case EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT:
            return null
        default:
            return state
    }
}
const coverage = (function() {

    function coverage(state = null, action) {
        switch (action.type) {
            case PROVIDER_COVERAGE_LOADED:
                return action.coverage
            default:
                return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case PROVIDER_COVERAGE_LOADED:
                return action.query
            default:
                return state
        }
    }

    function criteria(state = {activityUids: config.data.providerCoverageCriteriaActivityUids.map((u) => ({uid: u}))}, action) {
        switch (action.type) {
            case PROVIDER_COVERAGE_CRITERIA_UPDATED:
                return {...state, ...action.criteria}
            default:
                return state
        }
    }

    return combineReducers({
        coverage,
        query,
        criteria
    })
})()

const contact = (function() {

    function stream(state = [], action) {
        switch (action.type) {
            case CONTACT_STREAM_LOADED:
            case CONTACT_STREAM_QUERIED:
                return action.stream
            default:
                return state
        }
    }

    function range(state = null, action) {
        switch (action.type) {
            case CONTACT_STREAM_LOADED:
            case CONTACT_STREAM_QUERIED:
                return action.range
            default:
                return state
        }
    }

    function _links(state = [], action) {
        switch (action.type) {
            case CONTACT_LINKS_LOADED:
            case CONTACT_STREAM_LOADED:
            case CONTACT_STREAM_QUERIED:
                return action._links
            default:
                return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case CONTACT_STREAM_LOADED:
            case CONTACT_STREAM_QUERIED:
                return action.query
            default:
                return state
        }
    }

    function suggest(state = [], action) {
        switch (action.type) {
            case CONTACT_SUGGEST_LOADED:
            case CONTACT_SUGGEST_QUERIED:
                return action.suggest
            default:
                return state
        }
    }

    function criteria(state = null, action) {
        switch (action.type) {
            case CONTACT_CRITERIA_UPDATED:
                return {...state, ...action.criteria}
            default:
                return state
        }
    }

    function minorCriteria(state = null, action) {
        switch (action.type) {
            case CONTACT_MINOR_CRITERIA_UPDATED:
                return {...state, ...action.minorCriteria}
            case CONTACT_MINOR_CRITERIA_RESET:
                return null
            default:
                return state
        }
    }

    function contact(state = null, action) {
        switch (action.type) {
            case CONTACT_LOADED:
                return action.contact
            default:
                return state
        }
    }

    function contactStats(state = null, action) {
        switch (action.type) {
            case CONTACT_LOADED:
                return action.contactStats
            default:
                return state
        }
    }

    function contactStatsQuery(state = null, action) {
        switch (action.type) {
            case CONTACT_LOADED:
                return action.contactStatsQuery
            default:
                return state
        }
    }

    function contactFilter(state = null, action) {
        switch (action.type) {
            case CONTACT_FILTER_UPDATED:
                return action.contactFilter
            default:
                return state
        }
    }

    return combineReducers({
        stream,
        range,
        _links,
        query,
        suggest,
        criteria,
        minorCriteria,
        contact,
        contactStats,
        contactStatsQuery,
        contactFilter
    })
})()

export default combineReducers({
    stream,
    range,
    _links,
    query,
    suggest,
    criteria,
    minorCriteria,
    coverage,
    provider,
    contact,
    referenceProviderCompanyCmd,
    addProviderContactCmd,
    updateProviderContactCmd,
    associateProviderContactWithProviderCompanyCmd,
    assignActivityToProviderCompanyCmd,
    defineUpdateInterventionPeriodForActivityCmd,
    defineServiceChargeForInterventionPeriodCmd,
    defineInterventionZoneForInterventionPeriodCmd,
    defineCallOutChargesForInterventionPeriodCmd,
    subscribeProviderCompanyToDirectoryForInterventionPeriodCmd,
    defineContactInfosForProviderCompanyCmd,
    defineRepairTimelimitForInterventionPeriodCmd,
    defineInterventionTimelimitForInterventionPeriodCmd,
    excludeOpeningTicketPurposesFromInterventionPeriodCmd
})


// WEBPACK FOOTER //
// ./lib/provider/reducers.js